import { propsErrorText } from "./FormElementos.Model.d";

export default function ErrorText(props: propsErrorText){
    return(
        <div className="text-danger error">{props.mensaje}</div>
    )    
}
